import { Chart } from '@frontend/chart/types';

import { createStackedTimeSeriesMockData } from '../../../mocks/create-time-series-mock-data';

export const TRANSACTION_VOLUME_BAR_CHART_MOCK_DATA: Chart = createStackedTimeSeriesMockData();
